import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsThreeDotsVertical, BiCheckDouble } from "react-icons/all";
import Chip from "../../assets/images/chip.png";
import straightVisaCard from "../../assets/images/straight_cards_32.png";
import "./index.css";
import info from "../../components/info";
import { useDispatch } from "react-redux";
import { UserAction } from "../../store/actions";
import CustomModal from "../modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";

export default function CreditCard({
  inputText,
  cardIcon,
  cardText,
  cardStyle,
  data,
  fromOrder,
  tickIcon,
  dotsIcon,
  paidText,
  shipVisaStyling,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  console.log("DATA==>", data);
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      {!data?.default_source && (
        <Menu.Item
          key="0"
          onClick={() => dispatch(UserAction.setCardDefaultReq(data.id))}
          style={{ marginLeft: "-5px" }}
        >
          <span className="st-primary">Set as default</span>
        </Menu.Item>
      )}

      <Menu.Item
        key="0"
        onClick={
          data?.default_source
            ? () => {
              info(
                "error",
                "Cannot delete default card! Make any other card your default and then delete this card"
              );
            }
            : () => setOpenModal(true)
        }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row justify={fromOrder ? "space-between" : "center"}>
      <Col xs={24} sm={24} md={24} lg={22} xl={22} className="custom">
        <Card className="ant-card-body" style={cardStyle}>
          <Row justify="start">
            <Col>
              {tickIcon && (
                <BiCheckDouble
                  color="lightblue"
                  size={25}
                  style={{
                    visibility: !data?.default_source ? "hidden" : "visible",
                  }}
                />
              )}
            </Col>
          </Row>
          <Row justify={"space-between"}>
            {paidText ? <Col style={{ margin: "8px" }}>Paid Via</Col> : null}

            <Col
              xs={5}
              sm={2}
              md={6}
              lg={4}
              xl={6}
              style={{
                margin: shipVisaStyling ? "8px -35px 0px 10px" : null,
                height: "28px",
                backgroundImage: !shipVisaStyling ? `url(${Chip}) ` : null,
                width: "28px",
                maxHeight: "28px",
                display: "flex",
                backgroundRepeat: "no-repeat",
                justifyContent: "end",
              }}
            >
              {shipVisaStyling ? <img src={Chip} /> : null}
            </Col>
            <Col
              xs={9}
              sm={3}
              md={8}
              lg={8}
              xl={6}
              style={{
                margin: shipVisaStyling ? "8px -7px 0px 10px" : null,
                height: "30px",
                backgroundImage: `url(${straightVisaCard}) `,
                width: "51px",
                display: "inline-block",
                position: "relative",
                backgroundPosition:
                  data?.payment_method_details?.card?.brand === "mastercard"
                    ? "0px -158px"
                    : "0px -74px",
                backgroundRepeat: "no-repeat",
              }}
            ></Col>
            <Col xs={8} sm={4} md={10} lg={10} xl={12}>
              {dotsIcon ? (
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  style={{ width: "40%" }}
                >
                  <BsThreeDotsVertical className="pointer-cursor" />
                </Dropdown>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <h5
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "20px 0",
                }}
              >
                {`**** **** **** ${data?.source?.last4 || 4242}`}
              </h5>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xl={12} sm={8} md={12} xs={10} lg={12}>
              <span className="card-countryName">
                {" "}
                {data?.source?.country || "US"}
              </span>
              <span className="card-country">COUNTRY</span>
            </Col>
            <Col xs={10} sm={8} md={12} lg={12} xl={12}>
              <span className="card-expiryDate">{`${data?.source?.exp_month || 12
                }/${data?.source?.exp_year || 2023}`}</span>
              <span className="card-expiry">EXP</span>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    UserAction.deleteCardReq(data.id, () => setOpenModal(false))
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
}
